import { connect } from 'react-redux';
import Actions from '../../Actions/Creators';
import Support from './Component/Support'

const mapStateToProps = (state) => ({
  glossary : state.organization.glossary
})

const mapDispatchToProps = (dispatch) => ({
  getGlossary: () => dispatch(Actions.getGlossary())
})

export default connect(mapStateToProps, mapDispatchToProps)(Support)


// WEBPACK FOOTER //
// ./src/Containers/SupportContainer/index.js